// Didn't want to use jQuery but that's all bootstrap is using...
// This initializes all tooltips on a page 
$('[data-toggle="tooltip"]').tooltip();

$('body').tooltip({
    selector: '[data-toggle="tooltip"]'
});